import { render, staticRenderFns } from "./cletnyLabel.vue?vue&type=template&id=524a02cb&"
import script from "./cletnyLabel.vue?vue&type=script&lang=js&"
export * from "./cletnyLabel.vue?vue&type=script&lang=js&"
import style0 from "./cletnyLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports